export default __webpack_public_path__ + "static/Sektor_logo-de608458d13c01bc4ab8eebd21a6e84c.jpg";